<template>
  <div v-if="isVisible" class="options-overlay">
    <div class="background" @mouseover="clearHideTimer" @click="expand"></div>
    <div class="options" @mouseover="clearHideTimer">
      <icon  v-if="canAnnotate" type="post" class="option post" @edit="edit"></icon>
      <icon  type="deleting" class="option deleting" @deleting="deleting"></icon>
    </div>
  </div>
</template>

<script>
import Icon from './Icon'

export default {
  components: {
    Icon
  },

  props: ['show', 'canAnnotate', 'canPreview'],

  data: function () {
    return {
      hideTimer: null
    }
  },

  computed: {
    isVisible: function () {
      return this.show
    }
  },

  methods: {
    clearHideTimer: function () {
      if (this.hideTimer !== null) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
    },
    hide: function () {
      if (this.hideTimer === null) {
        this.hideTimer = setTimeout(() => { this.$emit('hide') }, 250)
      }
    },
    deleting: function () {
      this.$emit('deleting')
    },
    edit: function () {
      this.$emit('edit')
    },
    expand: function () {
      this.$emit('expand')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.options-overlay {
  cursor: pointer;
  position:absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  color:red;

  .background {
    cursor: pointer;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    bottom: 0;
    opacity: 0.5;
    z-index: 2;
  }

  .options {
    position: relative;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
    height: 100%;
    color: red;

    .option {
      display: flex;
      flex-direction: row;
      align-items: center;

      &.post {
        margin: 1rem 0 0 1rem;
      }

      &.deleting {
        margin: 1rem 0 0 1rem;
      }
    }
  }
}
</style>
